module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-teaser-block"
  }, [_c('h3', [_vm._v(_vm._s(_vm.teaserData.title))]), _vm._v(" "), (_vm.teaserData.link_text && _vm.teaserData.link_url) ? _c('a', {
    staticClass: "c-teaser-block__contactlink",
    attrs: {
      "href": _vm.teaserData.link_url
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.teaserData.link_text) + "\n\t")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b0626a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TeaserBlock.vue
// module id = 268
// module chunks = 0